import localizeTitle from './localizeTitle';
import userLanguageSelector from './userLanguageSelector';
import localizeCtaText from './localizeCtaText';
import localizeBannerText from './localizeBannerText'

export {
  localizeTitle,
  userLanguageSelector,
  localizeCtaText,
  localizeBannerText
};